import styled from "styled-components/native";
import { ADMIN_COLORS } from "../../../config/theme/adminColors";

export const FlexBox = styled.View`
  align-items: center;
  flex-direction: row;
  gap: 4px;
  width: 100%;
`;

export const Select = styled.Picker`
  flex: 1;
  min-width: 0px;
  height: 40px;
  border-radius: 10px;
  border: 1px solid ${ADMIN_COLORS.border};
  padding: 0px 12px;
  background-color: ${ADMIN_COLORS.surface};
  color: ${ADMIN_COLORS.ink};
`;
